// Button
import { Button as ChakraButton, type ButtonProps as ChakraButtonProps } from '@chakra-ui/react';
import { Translation, useTranslatedContent } from './translation';

// Button component with translation support
export interface ButtonProps extends ChakraButtonProps {
  path?: string;
  loadingText?: string;
}

export const Button = ({ path, children, loadingText, ...props }: ButtonProps) => {
  const translatedLoadingText = useTranslatedContent(loadingText);

  return (
    <Translation
      path={path}
      children={children}
      render={(content) => (
        <ChakraButton {...props} loadingText={translatedLoadingText}>
          {content}
        </ChakraButton>
      )}
    />
  );
};
